// Add Bootstrap's .form-group to Unpoly v3 group selectors (was included by default in v1).
// This ensures [up-validate=''] on inputs replaces only the closest .form-group, not the entire form.
up.form.config.groupSelectors.push('.form-group')

up.compiler('[up-replace]', (element) =>{
    var target = element.getAttribute('up-replace');
    element.addEventListener("click", function(){
        up.render({target: target, url: window.location.pathname});
    });
});

up.compiler('.modal--close', (element) =>{
    if(up.layer.isOverlay()){
        element.setAttribute('up-dismiss', '')
    }
});

up.compiler('input[up-history]', (element) =>{
    var url = element.getAttribute('up-history')
    element.onclick = function(){ history.pushState({}, '', url) }
});

up.compiler('a[up-request]', (element) =>{
    if(element.getAttribute('up-request') == 'true') {
        up.follow(element)
    }
});

up.compiler('[up-switch-click]', (element) => {
    var toggles = document.querySelectorAll(element.getAttribute('up-switch-click'));
    register_next_btn(element, toggles);
});

up.compiler('[up-modal-close-after]', (element) => {
    element.addEventListener('click', (event) => {
        if(up.layer.isOverlay()){
            setTimeout(function(){
                up.layer.dismiss()
            }, element.getAttribute('up-modal-close-after')*1000)
        }
    })
});

up.compiler('[up-fill]', (element) => {
    let target = document.querySelector(element.getAttribute('up-target'));
    let newValue = element.getAttribute('up-fill');
    if(target.tagName == 'INPUT'){
        element.addEventListener("click", function(){
            target.value = newValue;
        });
    }
});


function click_toggle(toggles){
    toggles.forEach((toggle) => {
        if(toggle.classList.contains('d-none')){
            toggle.classList.remove('d-none');
        } else {
            toggle.classList.add('d-none');
        }
    })
}

function register_next_btn(element, toggles){
    if(element.hasAttribute('up-switch-click-btn')){
        var nextBtn = document.querySelector(element.getAttribute('up-switch-click-btn'))

        if(!element.classList.contains('up-switch-click-registered')){
            element.addEventListener('click', (event) => {
                click_toggle(toggles);
                element.classList.add('d-none');
                nextBtn.classList.remove('d-none');
            })

            element.classList.add('up-switch-click-registered')
            register_next_btn(nextBtn, toggles);
        }
    }
}
